import React from "react";
import CoversureLogo from '../../assets/svg/coversure-logo.svg';
interface LayoutProps {
  children: React.ReactNode;
}
const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      {/* Main Content */}
      <main className="flex-grow">{children}</main>

      {/* Footer */}
      <footer className="text-gray-600 pb-4 text-center text-sm lg:border-t-[1px] border-border-color-1">
        <div className="w-[100%] lg:flex block justify-between px-[10px] lg:px-[60px] pb-[10px] lg:pb-[60px] pt-[10px] lg:pt-[40px]">
          <div className="border-b-[1px] border-border-color-1 lg:border-none pb-[14px] lg:pb-[0px]">
            <img src={CoversureLogo} alt="CoversureLogo" className="h-[18px] lg:h-[35px]"/>
          </div>
          <div className="font-normal text-[12px] leading-[24px] lg:text-[16px] lg:leading-[26px] text-text-color-6 text-justify pt-[14px] lg:pt-[0px]">
            <span className="font-medium">
              Claycove23 Insurance Tech Pvt. Ltd.
            </span>
            <br />
            <span className="font-medium">CIN:</span> U74999MH2022PTC396393
            <br />
            <span className="font-medium">IRDAI Reg. No:</span> CA0894
            <br />
            <span className="font-medium">Category:</span> Corporate Agent
            (Composite)
            <br />
            <span className="font-medium">Validity:</span> till 9th Jan’2027
          </div>
        </div>
        <p className="font-normal lg:text-[14px] lg:leading-[18px] text-[12px] leading-[15px] text-text-color-6 text-justify lg:text-center px-[10px]">
          Copyright 2024. CoverSure. All Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default MainLayout;
